import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';

import { Grid, units } from '@hbf/dsl';
import { StarRating } from 'ha/ui/StarRating';
import { useFeatureFlags } from 'ha/modules/FeatureFlags';
import { getGroupedListings } from 'ha/pages/UserPage/reducer';
import { TenantReviewsSpecificCountries } from 'ha/constants/TenantReviewsSpecificCountries';

import { getTenantReviewsOverallRating } from 'ha/pages/Listing/reducer';

const useStyles = makeStyles()(theme => ({
  ratingSection: {
    marginLeft: 'auto',
  },
  ratingContainer: {
    backgroundColor: theme.palette.white.main,
    width: 'fit-content',
    borderRadius: units.rem(1),
    padding: units.rem(0.4),
    fontSize: units.rem(0.75),
    fontWeight: 600,
  },
  totalRatingValue: {
    color: theme.palette.grey[400],
  },
  star: {
    marginRight: units.rem(0.2),
  },
}));

const UserReviewsRating: React.FC = () => {
  const { classes } = useStyles();

  const { showTenantReviews } = useFeatureFlags();
  const groupedListings = useSelector(getGroupedListings);
  const tenantReviewsOverallRating = useSelector(getTenantReviewsOverallRating);

  const canDisplayRating = useMemo(
    () =>
      showTenantReviews === 'on' &&
      groupedListings?.length > 0 &&
      groupedListings.every(group =>
        TenantReviewsSpecificCountries.some(
          specificCountry => specificCountry.name === group.country,
        ),
      ),
    [showTenantReviews, groupedListings],
  );

  if (!canDisplayRating) return null;

  return (
    <Grid item justifyContent="flex-end" className={classes.ratingSection}>
      <Grid
        container
        direction="row"
        alignItems="flex-end"
        className={classes.ratingContainer}
      >
        <StarRating
          max={1}
          readOnly
          value={tenantReviewsOverallRating.moveInOverallRating ? 1 : 0}
          size="small"
          className={classes.star}
          data-test-locator="Review Rating"
        />
        {parseFloat(
          `${tenantReviewsOverallRating.moveInOverallRating}`,
        ).toFixed(1)}
        <span className={classes.totalRatingValue}>/5</span>
      </Grid>
    </Grid>
  );
};

export { UserReviewsRating };
